enum Status {
  New = "new",
  Completed = "completed"
}

export default Status
